// @flow
export { default } from './MainHead';



// WEBPACK FOOTER //
// ./src/components/main/MainHead/index.js